export const PLATFORM_SUSPENDED_ERROR_CODE = 'PLATFORM_SUSPENDED';

const SCREEN_ID = 'platform-suspended-screen';

// Plain DOM on purpose: it's triggered from RestApiService, outside React, and has to cover both
// bundles (client + business) regardless of which route/layout is mounted.
export function showPlatformSuspendedScreen(message?: string): void {
  if (typeof document === 'undefined' || document.getElementById(SCREEN_ID)) return;

  const screen = document.createElement('div');
  screen.id = SCREEN_ID;
  screen.setAttribute('role', 'alert');
  Object.assign(screen.style, {
    position: 'fixed',
    inset: '0',
    zIndex: '2147483647',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
    background: '#fff',
    color: '#1a1a1a',
    fontFamily: 'sans-serif',
    textAlign: 'center',
  });

  const title = document.createElement('h1');
  title.style.fontWeight = '500';
  // textContent, not innerHTML - the message comes from the server setting.
  title.textContent = message || 'Voopty';
  screen.appendChild(title);

  document.body.appendChild(screen);
}

export function handlePlatformSuspended(status: number, body: any): void {
  if (status === 503 && body?.errorCode === PLATFORM_SUSPENDED_ERROR_CODE) {
    showPlatformSuspendedScreen(body.message);
  }
}
